import { useEffect } from "react";
import MainStyle from "./Main.module.css";
import Map from "./components/map/Map"
import useDevice from "../../shared/hooks/useDevice";
import clsx from "clsx";
import useSensorStatus from "./hooks/useSensorStatus";
import SensorStatusContainer from "./components/SensorStatusContainer";
import { useAppDispatch } from "../../shared/store/store";
import { resetDashboard } from "./slice/sensorDashboardSlice";

function Main({name}) {
    const { items } = useSensorStatus();
    const device = useDevice();
    const dispatch = useAppDispatch();

    // 컴포넌트 마운트 시 대시보드 상태 초기화
    useEffect(() => {
        dispatch(resetDashboard());
    }, [dispatch]);

    return (
    <div 
        className={
            clsx(
                MainStyle.main,
            )
        }
    >
        {(device === "desktop" || device === "tablet") && (
            <div className={MainStyle["side-tab-container"]}>
                <SensorStatusContainer items={items} colorful/>
            </div>
        )}
        <Map/>
    </div>
    )
}

export default Main;